import { FC, memo } from 'react';
import cx from 'clsx';

import styles from './styles.module.css';
import { createPortal } from 'react-dom';
import { MutatingDots } from 'react-loader-spinner';

type Props = {
  isLoading: boolean;
};

export const DefaultLoader: FC<Props> = memo(({ isLoading }) =>
  createPortal(
    <div
      className={cx({
        [styles.wrapper]: true,
        [styles.wrapperDefault]: true,
        [styles.wrapperDefaultShow]: isLoading,
      })}
    >
      <div>
        <MutatingDots
          height="100"
          width="100"
          color="white"
          secondaryColor="white"
          radius="12.5"
          ariaLabel="main-loader"
          visible={isLoading}
        />
      </div>
    </div>,
    document.body
  )
);
